import axios from "axios";
import { baseUri } from "../config/config";

axios.defaults.headers.post["Content-Type"] = "application/json";

const joinApiUrl = (base, path) => {
  const root = String(base || "").replace(/\/+$/, "");
  const route = String(path || "").replace(/^\/+/, "");
  return `${root}/${route}`;
};

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
}) {
  const reqObj = {
    method,
    url: joinApiUrl(baseUri, path),
    headers,
  };

  reqObj.params = queryParams;

  if (method === "POST") {
    reqObj.data = postData;
  }
  if (method === "PUT") {
    reqObj.data = postData;
  }
  if (method === "DELETE") {
    reqObj.data = postData;
  }

  let results;
  if (postData instanceof FormData) {
    console.info(...postData, "<===REQUEST-DATA===>");
  }
  console.info("<===REQUEST-OBJECT===>", reqObj);

  try {
    results = await axios(reqObj);
    console.info("<===Api-Success-Result===>", results);

    return results.data;
  } catch (error) {
    console.info("<===Api-Error===>", error.response?.data || error.message);

    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return {
      code: error.response?.status || 500,
      message: error.response?.data?.message
        ? error.response.data.message
        : error.message || "",
      ...(error.response?.data?.errors
        ? { errors: error.response.data.errors }
        : {}),
      // Password-protected journeys: keep the gate flag + list-level tracker.
      ...(error.response?.data?.requirePassword
        ? {
            requirePassword: true,
            ...(error.response.data.tracker
              ? { tracker: error.response.data.tracker }
              : {}),
          }
        : {}),
    };
  }
}
